export default {
  error2FA: {
    en: "2FA Error",
  },
  messageSend: {
    en: "A message with a verification code has been sent to your email. Enter the code to continue.",
    ja: "確認コードが記載されたメッセージがメールに送信されました。 コードを入力して続行します。"
  },
  cancel: {
    en: "Cancel",
    ja: "キャンセル"
  }
}
